import { SnackbarProvider } from "notistack";
import "../src/assets/css/theme.css";
import "../src/assets/css/project.css";
import "../src/assets/css/style.css";
import "../src/assets/css/new-style.css";
import "../src/assets/css/tailwindStyles.css";
import ApppRoutes from "./routes";
import { ThemeProvider } from "@mui/material/styles";
import theme from "./generalComponnets/themes/MuiTheme";
import { IdsProvider } from "./hook/AdminContext";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "react-image-gallery/styles/css/image-gallery.css";
import GoogleAnalytics from "./GoogleAnalytic";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { useEffect, useRef } from "react";
import { project_mode } from "./config/config";

// Initialize Stripe
const stripePromise = loadStripe(
  process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY ||
    "your-stripe-publishable-key-here",
);

function App() {
  // const baseline = useRef({
  //   widthDiff: window.outerWidth - window.innerWidth,
  //   heightDiff: window.outerHeight - window.innerHeight,
  //   zoom: window.devicePixelRatio,
  // });

  // // if (
  // //   (project_mode === "prod" || project_mode === "stage") &&
  // //   window?.location?.hostname !== "localhost"
  // // ) {
  // //   const immediateDevToolsCheck = () => {
  // //     let isCompleteRender = localStorage.getItem("isCompleteRender");

  // //     const isMobile =
  // //       /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
  // //         navigator.userAgent
  // //       );
  // //     // Debug log
  // //     if (isMobile) return;

  // //     const currentWidthDiff = window.outerWidth - window.innerWidth;
  // //     const currentHeightDiff = window.outerHeight - window.innerHeight;
  // //     const currentZoom = window.devicePixelRatio;

  // //     // Ignore if zoom level changed (before or after load)
  // //     if (currentZoom !== baseline.current.zoom) return;

  // //     // Detect if DevTools docking created a large viewport change
  // //     const widthThreshold =
  // //       currentWidthDiff - baseline.current.widthDiff > 160;
  // //     const heightThreshold =
  // //       currentHeightDiff - baseline.current.heightDiff > 160;
  // //     setTimeout(() => {
  // //       if ((widthThreshold || heightThreshold) && !isCompleteRender) {
  // //         window.location.href = "about:blank";
  // //         return;
  // //       } else {
  // //         localStorage.setItem("isCompleteRender", true);
  // //       }
  // //     }, 1000);
  // //   };

  // //   immediateDevToolsCheck();
  // // }
  // useEffect(() => {
  //   if (
  //     (project_mode === "prod" || project_mode === "stage") &&
  //     window?.location?.hostname !== "localhost"
  //   ) {
  //     let devtoolsOpen = false;

  //     const detectDevTools = () => {
  //       const isMobile =
  //         /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
  //           navigator.userAgent
  //         );
  //       if (isMobile) return;

  //       // Method 1: Viewport size detection
  //       const currentWidthDiff = window.outerWidth - window.innerWidth;
  //       const currentHeightDiff = window.outerHeight - window.innerHeight;
  //       const currentZoom = window.devicePixelRatio;

  //       // Update baseline if zoom changed (to handle zoom changes)
  //       if (currentZoom !== baseline.current.zoom) {
  //         baseline.current = {
  //           widthDiff: currentWidthDiff,
  //           heightDiff: currentHeightDiff,
  //           zoom: currentZoom,
  //         };
  //         return;
  //       }

  //       // Detect if DevTools docking created a large viewport change
  //       const widthThreshold =
  //         Math.abs(currentWidthDiff - baseline.current.widthDiff) > 160;
  //       const heightThreshold =
  //         Math.abs(currentHeightDiff - baseline.current.heightDiff) > 160;

  //       // Method 2: Console timing detection
  //       let start = performance.now();
  //       console.profile();
  //       console.profileEnd();
  //       let timingDetected = performance.now() - start > 5;

  //       // Method 3: Check if window is significantly smaller (devtools taking space)
  //       const windowTooSmall =
  //         window.innerWidth < 500 || window.innerHeight < 300;

  //       let isCompleteRender = localStorage.getItem("isCompleteRender");

  //       if (
  //         (widthThreshold || heightThreshold || timingDetected) &&
  //         !isCompleteRender
  //       ) {
  //         if (!devtoolsOpen) {
  //           devtoolsOpen = true;
  //           window.location.href = "about:blank";
  //         }
  //       }
  //     };

  //     // Run detection every 200ms
  //     const devToolsInterval = setInterval(detectDevTools, 200);
  //     // Run debugger detection every 1000ms (less frequent as it's more intrusive)

  //     const handleContextMenu = (e) => {
  //       e.preventDefault();
  //       localStorage.removeItem("isCompleteRender");
  //     };
  //     const disableInspect = (e) => {
  //       if (
  //         e.keyCode === 123 || // F12
  //         (e.ctrlKey && e.shiftKey && e.keyCode === 73) || // Ctrl+Shift+I
  //         (e.ctrlKey && e.shiftKey && e.keyCode === 74) || // Ctrl+Shift+J
  //         (e.ctrlKey && e.keyCode === 85) || // Ctrl+U
  //         (e.metaKey && e.altKey && e.keyCode === 73) || // Cmd+Option+I (Mac)
  //         (e.metaKey && e.altKey && e.keyCode === 74) || // Cmd+Option+J (Mac)
  //         (e.metaKey && e.keyCode === 85) // Cmd+U (Mac)
  //       ) {
  //         e.preventDefault();
  //         localStorage.removeItem("isCompleteRender");
  //       }
  //     };

  //     // document.addEventListener("contextmenu", handleContextMenu);
  //     document.addEventListener("keydown", disableInspect);

  //     return () => {
  //       clearInterval(devToolsInterval);
  //       // document.removeEventListener("contextmenu", handleContextMenu);
  //       document.removeEventListener("keydown", disableInspect);
  //     };
  //   }
  // }, []);

  // if (window.location.hostname !== "localhost") {
  //   console.log = () => {};
  // }

  useEffect(() => {
    if (process.env.REACT_APP_PROJECT_MODE !== "prod") {
      const meta = document.createElement("meta");
      meta.name = "robots";
      meta.content = "noindex, nofollow, noarchive";
      // Insert at the beginning of <head>
      const head = document.head;
      if (head.firstChild) {
        head.insertBefore(meta, head.firstChild);
      } else {
        head.appendChild(meta);
      }
    }
  }, []);

  if (
    (project_mode === "prod" || project_mode === "stage") &&
    window?.location?.hostname !== "localhost"
  ) {
    const noop = () => {};
    window.console = {
      ...window.console,
      log: noop,
      warn: noop,
      info: noop,
      debug: noop,
    };
  }

  return (
    <>
      <ThemeProvider theme={theme}>
        <SnackbarProvider
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "right",
          }}
          maxSnack={3}
        >
          <Elements stripe={stripePromise}>
            <IdsProvider>
              <GoogleAnalytics />
              <ApppRoutes />
            </IdsProvider>
          </Elements>
        </SnackbarProvider>
      </ThemeProvider>
    </>
  );
}

export default App;
